export const SITE_VISITS_INDEX = 1574;
export const SITE_VISITS_ASSIGN = 1575;
export const SITE_VISITS_RESCHEDULE = 1576;
export const SITE_VISITS_CANCEL = 1577;
export const SITE_VISITS_COMPLETE = 1578;
export const SITE_VISITS_DELETE = 1579;
export const SITE_VISITS_RESTORE = 1580;

export const SITE_VISITS_ROSTER_UPDATE = 1581;

export const SITE_VISITS_ROSTER_INDEX = SITE_VISITS_INDEX;

export const SITE_VISITS_SETTINGS_INDEX = 1582;
export const SITE_VISITS_SETTINGS_UPDATE = SITE_VISITS_SETTINGS_INDEX;
